import { AnimDiv } from "@aaa/animdiv";
import {
    debug, form, formHelpers, Formsy,
    helpers, i18n, inject, observable, observer, React, RouteComponentProps, theme, ui,
    pr
} from "aaa";
import { SALUTATIONS, TITLES, User } from "models/User";
import { PersonalDataContent, PersonalDataForm, EmploymentComponent } from "./PersonalDataForm";
import * as mui from "material-ui";
import * as _ from "lodash";

export const BaseDataSecondBorrower = (props: { user: User }) => {
    return (
        <div>
            <form.FormsySelect
                name="secondBorrowerSalutation"
                required={true}
                fullWidth={true}
                floatingLabelText={ui.__("salutation")}
                validationError={ui.__("error.requiredField")}
                value={helpers.indexOfStringInKeyArray(props.user.secondBorrowerSalutation!, SALUTATIONS)}
            >
                {formHelpers.stringsToMenuItems(SALUTATIONS)}
            </form.FormsySelect>

            <form.FormsySelect
                name="secondBorrowerTitle"
                required={false}
                fullWidth={true}
                floatingLabelText={ui.__("title")}
                value={helpers.indexOfStringInKeyArray(props.user.secondBorrowerTitle!, TITLES)}
            >
                {formHelpers.stringsToMenuItems(TITLES)}
            </form.FormsySelect>

            <form.FormsyText
                name="secondBorrowerLastName"
                required={true}
                validations={"minLength:1"}
                floatingLabelText={ui.__("lastName")}
                fullWidth={true}
                validationError={ui.__("error.requiredField")}
                value={props.user.secondBorrowerLastName}
                onChange={(event: any, value: any) => props.user.secondBorrowerLastName = value}
            />
            <form.FormsyText
                name="secondBorrowerFirstName"
                required={true}
                validations={"minLength:1"}
                floatingLabelText={ui.__("firstName")}
                fullWidth={true}
                validationError={ui.__("error.requiredField")}
                value={props.user.secondBorrowerFirstName}
                onChange={(event: any, value: any) => props.user.secondBorrowerFirstName = value}
            />
            <form.FormsyText
                name="secondBorrowerBirthDate"
                required={true}
                validations="isDateDDMMYYYY"
                floatingLabelText={ui.__("birthDate")}
                fullWidth={true}
                validationError={ui.__("error.dateInvalid")}
                value={props.user.secondBorrowerBirthDate}
            />
        </div>
    );
};



type IProps = i18n.InjectedIntlProps & {
    user: User,
    isSummary?: boolean
};


@observer
export class BaseDataContent extends React.Component<IProps, {}> {


    constructor(props: IProps) {
        super(props);
        props.user.secondBorrowerToggled = props.user.hasSecondBorrower && props.isSummary !== true;
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {

        return (
            <div>
                <form.FormsySelect
                    name="salutation"
                    required={true}
                    fullWidth={true}
                    floatingLabelText={ui.__("salutation")}
                    validationError={ui.__("error.requiredField")}
                    value={helpers.indexOfStringInKeyArray(this.props.user.salutation, SALUTATIONS)}
                >
                    {formHelpers.stringsToMenuItems(SALUTATIONS)}
                </form.FormsySelect>

                <form.FormsySelect
                    name="title"
                    required={false}
                    fullWidth={true}
                    floatingLabelText={ui.__("title")}
                    value={helpers.indexOfStringInKeyArray(this.props.user.title, TITLES)}
                >
                    {[
                        /* allow empty selection -> value must be undefined. */
                        <mui.MenuItem key="empty" value={undefined} primaryText="" />,
                        ...formHelpers.stringsToMenuItems(TITLES)
                    ]}
                </form.FormsySelect>

                <formHelpers.UserTextField user={this.props.user} fieldName="lastName" />
                <formHelpers.UserTextField user={this.props.user} fieldName="firstName" />

                <form.FormsyText
                    name="country"
                    required={true}
                    validations="minLength:1"
                    floatingLabelText={ui.__("addressCountry")}
                    fullWidth={true}
                    value={ui.__("germany")}
                    disabled={true}
                    inputStyle={{ color: "black" }}
                    underlineStyle={{ opacity: "0.4" }}
                    validationError={ui.__("error.requiredField")}
                />


                <formHelpers.UserTextField user={this.props.user} fieldName="address" assignImmediaely={true} />
                <formHelpers.UserTextField user={this.props.user} fieldName="zipCode" assignImmediaely={true} />
                <formHelpers.UserTextField user={this.props.user} fieldName="residence" assignImmediaely={true} />

                <form.FormsyText
                    name="birthDate"
                    required={true}
                    validations="isDateDDMMYYYY"
                    floatingLabelText={ui.__("birthDate")}
                    fullWidth={true}
                    validationError={ui.__("error.dateInvalid")}
                    value={this.props.user.birthDate}
                />

                {!this.props.isSummary && formHelpers.renderYesNoGroup(
                    ui.__("secondBorrowerSpouse"),
                    "secondBorrower",
                    this.props.user.hasSecondBorrower,
                    (event: any, value: any) => {
                        this.props.user.secondBorrowerToggled = value === "yes";
                    })
                }

                <AnimDiv
                    key={this.props.user.secondBorrowerToggled ? 0 : 1}
                    animFunction={springValue => {
                        if (springValue > 0.99) {
                            springValue = 1;
                        }

                        return {
                            opacity: springValue,
                            height: springValue * 260,
                        };
                    }}
                >
                    {this.props.user.secondBorrowerToggled &&
                        <BaseDataSecondBorrower user={this.props.user} />}
                </AnimDiv>
            </div>
        );
    }
}


@i18n.injectIntl
@inject("user")
@observer
export class BaseDataForm extends React.Component<RouteComponentProps<{}> & IProps & { onSubmit: (keysSubmittedFields: string[]) => void }, {}> {

    @observable
    formIsValid = false;

    private formRef: any;

    static parseInput(user: User, fields: any) {
        user.salutation = ui.__(SALUTATIONS[fields.salutation] as i18n.IDS);
        user.title = fields.title !== undefined ? ui.__(TITLES[fields.title] as i18n.IDS) : "";
        user.firstName = fields.firstName;
        user.lastName = fields.lastName;
        user.country = fields.country;
        user.address = fields.address;
        user.zipCode = fields.zipCode;
        user.residence = fields.residence;
        user.birthDate = fields.birthDate;

        if (fields.secondBorrowerSalutation !== undefined) {
            user.secondBorrowerSalutation = ui.__(SALUTATIONS[fields.secondBorrowerSalutation] as i18n.IDS);
            user.secondBorrowerTitle = fields.secondBorrowerTitle ? ui.__(TITLES[fields.secondBorrowerTitle] as i18n.IDS) : "";
            user.secondBorrowerFirstName = fields.secondBorrowerFirstName;
            user.secondBorrowerLastName = fields.secondBorrowerLastName;
            user.secondBorrowerBirthDate = fields.secondBorrowerBirthDate;
        } else {
            user.secondBorrowerSalutation = undefined;
            user.secondBorrowerTitle = undefined;
            user.secondBorrowerFirstName = undefined;
            user.secondBorrowerLastName = undefined;
            user.secondBorrowerBirthDate = undefined;
        }
    }

    onSubmit = (fields: any, resetForm: any, invalidateForm: any) => {
        const user = this.props.user;
        BaseDataForm.parseInput(this.props.user, fields);
        PersonalDataForm.parseInput(this.props.user, fields);
        debug.log("### BaseData user", user);

        const submittedFields = _.compact(_.map(fields as _.Dictionary<any>, (value, key) => {
            return _.isNil(value) ? null : key;
        }));

        this.props.onSubmit(submittedFields);

        this.props.history.push("/contact");
    }

    componentDidMount() {

        // SUCCESS-REDIRECT: user has already fully submitted previously, hard redirect to /loan
        if (this.props.user.successfullySubmitted === true) {
            window.location.replace(window.location.origin + window.location.pathname); // we wont include hash - root page only.
        }
    }

    render() {
        return (
            <Formsy.Form
                onInvalidSubmit={(fields: any, reset: any, invalidate: any) => formHelpers.invalidateRequiredFields(this.formRef, invalidate)}
                onValidSubmit={this.onSubmit}
                onValid={() => { this.formIsValid = true; }}
                onInvalid={() => { this.formIsValid = false; }}
                noValidate
                ref={(c: any) => this.formRef = c}
            >
                <pr.FormContainer>
                    <BaseDataContent user={this.props.user} />
                </pr.FormContainer>
                <pr.Separator />
                <pr.FormContainer>
                    <PersonalDataContent user={this.props.user} />
                    {formHelpers.renderActionButton(ui.__("continue"))}
                </pr.FormContainer>
            </Formsy.Form>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/BaseDataForm.tsx